import { type ErrorNotifier } from "./error-notifier";
import { type ErrorConsumer } from "./error-consumer";

class ErrorServiceImpl implements ErrorConsumer, ErrorNotifier{
    private _handler?: (error: any) => boolean;
    
    public handleError(handler: (error: any) => boolean) {
        this._handler = handler;
    }

    public notifyError(error: any) {
        if (this._handler) {
            this._handler(error);
        }
    }

}

const instance = new ErrorServiceImpl();

export function useErrorConsumer(): ErrorConsumer {
    return instance;
}

export function useErrorNotifier(): ErrorNotifier {
    return instance;
}